"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
const services_1 = require("../services");
exports.LEASED_SPACE_STATUS = 'Leased';
class PropertyModel extends _1.BaseModel {
    static movePrimaryPhotoToFront(property) {
        if (property.usesBackUpImage
            || !property.defaultImageUrl
            || !property.imageUrls
            || !property.imageUrls.length) {
            return;
        }
        const i = property.imageUrls.indexOf(property.defaultImageUrl);
        if (i > 0) {
            property.imageUrls.splice(0, 0, property.imageUrls.splice(i, 1)[0]);
        }
        else if (i === -1) {
            property.imageUrls.splice(0, 0, property.defaultImageUrl);
        }
    }
    get mappingAPIFieldMap() {
        return {
            _id: 'sf_id',
            buildingLocation: 'building_location',
            class: 'class',
            defaultImageAttachmentId: 'image_attachment_id',
            description: 'description',
            floor: 'floor',
            landAcres: 'land_acres',
            landSquareFeet: 'land_sf',
            market: 'market',
            name: 'name',
            occupancy: 'occupancy',
            parcelNumber: 'apn',
            parentPropertyId: 'parent_property',
            parkingSpaces: 'parking_spaces',
            parkingRatio: 'parking_ratio2',
            postalCode: 'zip_code',
            primaryUse: 'primary_use',
            recordTypeId: 'record_type',
            saleDate: 'last_sale_date',
            salePrice: 'last_sale_price',
            spaceType: 'space_property_type',
            spaceStatus: 'space_status',
            spaceSubType: 'space_sub_type',
            squareFootage: 'square_footage',
            suiteFloor: 'suite_floor',
            state: 'state',
            status: 'status',
            stories: 'number_of_stories',
            street: 'street_address',
            submarket: 'submarket',
            tenancy: 'tenancy',
            units: 'units',
            yearBuilt: 'year_built',
            yearRenovated: 'year_renovated',
            zoning: 'zoning'
        };
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            averageUnitSize: 'McLabs2__Average_Unit_Size__c',
            averageWeightedRent: 'McLabs2__Average_Weighted_Rent__c',
            buildingLocation: 'McLabs2__Building_Location__c',
            buildingPark: 'McLabs2__Building_Park__c',
            category: 'Industry',
            ceilingHeight: 'McLabs2__Ceiling_Height__c',
            class: 'McLabs2__Class__c',
            columnSpacing: 'McLabs2__Column_Spacing__c',
            construction: 'McLabs2__Construction__c',
            coreFactor: 'McLabs2__Core_Factor__c',
            crossStreets: 'McLabs2__Cross_Streets__c',
            daysUntilLoanMaturity: 'McLabs2__Days_Until_Loan_Maturity__c',
            defaultImageAttachmentId: 'McLabs2__Image_Attachment_Id__c',
            description: 'McLabs2__Description__c',
            docks: 'McLabs2__Docks__c',
            driveIns: 'McLabs2__Drive_Ins__c',
            elevators: 'McLabs2__Elevators__c',
            floor: 'McLabs2__Floor__c',
            landAcres: 'McLabs2__Land_Acres__c',
            landSquareFeet: 'McLabs2__Land_SF__c',
            lastSaleDate: 'McLabs2__Last_Sale_Date__c',
            lastSalePrice: 'McLabs2__Last_Sale_Price__c',
            legalDescription: 'McLabs2__Legal_Description__c',
            lender: 'McLabs2__Lender__c',
            loanAmortization: 'McLabs2__Loan_Amortization__c',
            loanBalance: 'McLabs2__Loan_Balance__c',
            loanMaturityDate: 'McLabs2__Loan_Maturity_Date__c',
            loanPrincipal: 'McLabs2__Loan_Principal__c',
            ltv: 'McLabs2__LTV__c',
            market: 'McLabs2__Market__c',
            name: 'Name',
            numberOfOwners: 'McLabs2__of_Owners__c',
            occupancy: 'McLabs2__Occupancy__c',
            operator: 'McLabs2__Operator__c',
            ownerId: 'OwnerId',
            parcelNumber: 'McLabs2__APN__c',
            parentPropertyId: 'McLabs2__Parent_Property__c',
            parkingRatio: 'McLabs2__Parking_Ratio2__c',
            parkingSpaces: 'McLabs2__Parking_Spaces__c',
            power: 'McLabs2__Power__c',
            primaryUse: 'McLabs2__Primary_Use__c',
            railLines: 'McLabs2__Rail_Lines__c',
            recordTypeId: 'RecordTypeId',
            retailType: 'McLabs2__Retail_Type__c',
            rooms: 'McLabs2__Rooms__c',
            saleDate: 'McLabs2__Last_Sale_Date__c',
            salePrice: 'McLabs2__Last_Sale_Price__c',
            secondaryUse: 'McLabs2__Secondary_Use__c',
            siteContact: 'McLabs2__Site_Contact__c',
            spaceStatus: 'McLabs2__Space_Status__c',
            spaceSubType: 'McLabs2__Space_Sub_Type__c',
            spaceType: 'McLabs2__Space_Property_Type__c',
            sprinklers: 'McLabs2__Sprinklers__c',
            squareFootage: 'McLabs2__Square_Footage__c',
            state: 'McLabs2__State__c',
            status: 'McLabs2__Status__c',
            stories: 'McLabs2__Number_of_Stories__c',
            street: 'McLabs2__Property_Address__c',
            submarket: 'McLabs2__Submarket__c',
            suiteFloor: 'McLabs2__Suite_Floor__c',
            tenancy: 'McLabs2__Tenancy__c',
            typicalFloorSize: 'McLabs2__Typical_Floor_Size__c',
            units: 'McLabs2__Units__c',
            unitType: 'McLabs2__Unit_Type__c',
            website: 'McLabs2__Website__c',
            yearBuilt: 'McLabs2__Year_Built__c',
            yearRenovated: 'McLabs2__Year_Renovated__c',
            youtubeUrl: 'McLabs2__Youtube_Url__c',
            zipCode: 'McLabs2__Zip_Code__c',
            zoning: 'McLabs2__Zoning__c'
        };
    }
    get pricePerSqft() {
        return (parseFloat(this.salePrice) / parseInt(this.squareFootage, 10)).toFixed(2).toString();
    }
    transformToSalesforce() {
        const sfProperty = super.transformToSalesforce();
        sfProperty.McLabs2__Property_Address__c = this.address.street;
        sfProperty.McLabs2__City__c = this.address.city;
        sfProperty.McLabs2__State__c = this.address.state;
        sfProperty.McLabs2__Zip_Code__c = this.address.postalCode;
        sfProperty.McLabs2__Square_Footage__c = this.squareFootage;
        sfProperty.McLabs2__Parking_Spaces__c = this.parkingSpaces;
        // can't upsert RecordType.Name, but still need it in the field map for queries
        delete sfProperty['RecordType.Name'];
        return sfProperty;
    }
    transformToMappingAPI() {
        const mappingProperty = {};
        Object.keys(this.mappingAPIFieldMap).forEach((key) => {
            mappingProperty[this.mappingAPIFieldMap[key]] = this[key];
        });
        mappingProperty.street_address = this.address.street;
        mappingProperty.city = this.address.city;
        mappingProperty.state = this.address.state;
        mappingProperty.zip_code = this.address.postalCode;
        mappingProperty.square_footage = this.squareFootage;
        mappingProperty.parking_spaces = this.parkingSpaces;
        return mappingProperty;
    }
    getForExport(usePrettyKeys = false) {
        const obj = {};
        Object.keys(PropertyModel.ExportFields).forEach(key => {
            const newKey = usePrettyKeys ? PropertyModel.ExportFields[key] : key;
            if (key === 'address' && this.address) {
                obj[newKey] = this.address.toString();
            }
            else {
                obj[newKey] = this[key] || null;
            }
        });
        return obj;
    }
    transformFromSalesforce(sfProperty) {
        super.transformFromSalesforce(sfProperty);
        this.name = (sfProperty.Name) ? sfProperty.Name.replace(/\r/, ' ') : '';
        if (sfProperty.RecordType) {
            this.type = sfProperty.RecordType.Name;
        }
        this.forSale = sfProperty.forSale;
        this.listingDate = sfProperty.listingDate;
        this.recentlySold = new Date(sfProperty.McLabs2__Last_Sale_Date__c) >
            new Date(new Date().setFullYear(new Date().getFullYear() - 1));
        const stateService = new services_1.StateService();
        this.address = new _1.AddressModel('Address', {
            street: sfProperty.McLabs2__Property_Address__c,
            city: sfProperty.McLabs2__City__c,
            state: sfProperty.McLabs2__State__c,
            stateCode: stateService.getStateCode(sfProperty.McLabs2__State__c),
            postalCode: sfProperty.McLabs2__Zip_Code__c,
            county: sfProperty.McLabs2__County__c,
            country: 'United States of America',
            countryCode: 'USA'
        });
        this.addressString = this.address.toString().replace(/\r/, ' ');
        if (sfProperty.McLabs2__Location__c) {
            this.location = {
                lat: sfProperty.McLabs2__Location__c.latitude,
                lng: sfProperty.McLabs2__Location__c.longitude
            };
        }
        if (PropertyModel.hostUrl) {
            this.usesBackUpImage = true;
            if (sfProperty.McLabs2__Image_Attachment_Id__c) {
                this.defaultImageUrl = `${PropertyModel.hostUrl}/api/image/${sfProperty.McLabs2__Image_Attachment_Id__c}`;
                this.usesBackUpImage = false;
            }
        }
        this.imageLoaded = false;
    }
    transformFromJson(json) {
        Object.assign(this, json);
        this.address = new _1.AddressModel('Address', json.address || {
            street: json.street,
            city: json.city,
            state: json.state,
            stateCode: json.stateCode,
            postalCode: json.postalCode,
            county: json.county,
            country: json.country,
            countryCode: json.countryCode
        });
    }
    transformFromMappingJson(json) {
        Object.assign(this, json);
        this.address = new _1.AddressModel('Address', json.address || {
            street: json.street,
            city: json.city,
            state: json.state,
            stateCode: json.stateCode,
            postalCode: json.postalCode,
            county: json.county,
            country: json.country,
            countryCode: json.countryCode
        });
        if (json.latitude && json.longitude) {
            this.location = {
                lat: json.latitude,
                lng: json.longitude
            };
        }
        this.addressString = this.address.toString().replace(/\r/, ' ');
        if (PropertyModel.hostUrl) {
            this.usesBackUpImage = true;
            if (json.defaultImageAttachmentId) {
                this.defaultImageUrl = `${PropertyModel.hostUrl}/api/image/${json.defaultImageAttachmentId}`;
                this.usesBackUpImage = false;
            }
        }
        this.imageLoaded = false;
    }
}
PropertyModel.PrimaryUse = [
    'Flex- Data Hosting',
    'Industrial Live & Work Unit',
    'Light Distribution',
    'Light Manufacturing',
    'Loft & Creative Space',
    'Medical',
    'None',
    'Office & Residential',
    'Office- Data Hosting',
    'Office Live & Work Unit',
    'Office with street-level Retail',
    'R&D',
    'Showroom'
];
PropertyModel.Market = [
    '',
    'AK-Anchorage',
    'AL-Birmingham',
    'AL-Huntsville',
    'AL-Mobile',
    'AL-Montgomery',
    'AR-Fayetteville/Springdale/Rogers',
    'AR-Fort Smith',
    'AR-Little Rock/N Little Rock',
    'AZ-Phoenix',
    'AZ-Tucson',
    'CA-Bakersfield',
    'CA-East Bay/Oakland',
    'CA-Fresno',
    'CA-Inland Empire',
    'CA-Los Angeles',
    'CA-Marin/Sonoma',
    'CA-Orange County',
    'CA-Sacramento',
    'CA-Salinas',
    'CA-San Diego',
    'CA-San Francisco',
    'CA-San Luis Obispo/Paso Robles',
    'CA-Santa Barbara/Sta Maria/Goleta',
    'CA-Santa Cruz/Watsonville',
    'CA-South Bay/San Jose',
    'CA-Stockton/Modesto',
    'CA-Visalia/Porterville',
    'CO-Colorado Springs',
    'CO-Denver',
    'CT-Hartford',
    'DC-Washington',
    'FL-Deltona/Daytona Beach',
    'FL-Jacksonville',
    'FL-Ocala',
    'FL-Orlando',
    'FL-Pensacola/Ferry Pass/Brent',
    'FL-Port St Lucie/Fort Pierce',
    'FL-South Florida',
    'FL-Southwest Florida',
    'FL-Tallahassee',
    'FL-Tampa/St. Petersburg',
    'GA-Atlanta',
    'GA-Augusta/Richmond County',
    'GA-Columbus',
    'GA-Savannah',
    'HI-Hawaii',
    'IA-Des Moines',
    'ID-Boise City/Nampa',
    'IL-Chicago',
    'IL-Davenport/Moline/Rock Island',
    'IL-Peoria',
    'IL-Springfield',
    'IN-Evansville',
    'IN-Fort Wayne',
    'IN-Indianapolis',
    'IN-South Bend/Mishawaka',
    'KS-Kansas City',
    'KS-Wichita',
    'KY-Lexington/Fayette',
    'KY-Louisville',
    'LA-Baton Rouge',
    'LA-Lafayette',
    'LA-New Orleans/Metairie/Kenner',
    'LA-Shreveport/Bossier City',
    'MA-Boston',
    'MD-Baltimore',
    'ME-Portland/South Portland',
    'MI-Detroit',
    'MI-Grand Rapids',
    'MN-Duluth',
    'MN-Minneapolis',
    'MO-St. Louis',
    'MS-Jackson',
    'National',
    'NC-Asheville',
    'NC-Charlotte',
    'NC-Fayetteville',
    'NC-Greensboro/Winston-Salem',
    'NC-Raleigh/Durham',
    'NC-Wilmington',
    'NE-Lincoln',
    'NE-Omaha/Council Bluffs',
    'NJ-Northern New Jersey',
    'NM-Albuquerque',
    'NV-Las Vegas',
    'NV-Reno/Sparks',
    'NY-Albany/Schenectady/Troy',
    'NY-Buffalo/Niagara Falls',
    'NY-Long Island',
    'NY-New York City',
    'NY-Rochester',
    'NY-Syracuse',
    'NY-Utica/Rome',
    'OH-Cincinnati/Dayton',
    'OH-Cleveland',
    'OH-Columbus',
    'OH-Toledo',
    'OH-Youngstown/Warren',
    'OK-Oklahoma City',
    'OK-Tulsa',
    'OR-Portland',
    'PA-Erie',
    'PA-Philadelphia',
    'PA-Pittsburgh',
    'RI-Providence',
    'SC-Charleston/N Charleston',
    'SC-Columbia',
    'SC-Greenville/Spartanburg',
    'SC-Myrtle Beach/Conway',
    'TN-Chattanooga',
    'TN-Kingsport/Bristol/Bristol',
    'TN-Knoxville',
    'TN-Memphis',
    'TN-Nashville',
    'TX-Austin',
    'TX-Beaumont/Port Arthur',
    'TX-Brownsville/Harlingen',
    'TX-Corpus Christi',
    'TX-Dallas/Fort Worth',
    'TX-El Paso',
    'TX-Houston',
    'TX-Killeen/Temple/Fort Hood',
    'TX-Lubbock',
    'TX-McAllen/Edinburg/Pharr',
    'TX-San Antonio',
    'UT-Salt Lake City',
    'VA-Hampton Roads',
    'VA-Richmond',
    'VA-Roanoke',
    'WA-Bremerton',
    'WA-Olympia',
    'WA-Seattle/Puget Sound',
    'WA-Spokane',
    'WA-Yakima',
    'WI-Green Bay',
    'WI-Milwaukee/Madison',
    'WV-Charleston',
    'WV-Huntington/Ashland'
];
PropertyModel.Submarket = [
    'Downtown',
    'Uptown',
    'Northside',
    'Southside'
];
PropertyModel.SpaceType = [
    'Healthcare',
    'Industrial',
    'Land',
    'Office',
    'Retail',
    'Specialty'
];
PropertyModel.SpaceSubType = [
    'None',
    'Industrial- Flex Space',
    'Industrial- Manufacturing',
    'Industrial- Office Showroom',
    'Industrial- R&D',
    'Industrial- Truck Terminal/Hub',
    'Industrial- Warehouse',
    'Industrial- Distribution Warehouse',
    'Industrial- Refrigerated/Cold Storage',
    'Land- Industrial',
    'Land- Multifamily',
    'Land- Office',
    'Land- Residential',
    'Land- Retail',
    'Land- Commercial(Other)',
    'Office- Creative/Loft',
    'Office- Office Building',
    'Office- Governmental',
    'Office- Medical Office',
    'Office- R&D',
    'Retail- Restaurant',
    'Retail- Freestanding Building',
    'Retail- Retail (Other)',
    'Retail- Vehicle Related',
    'Retail- Pad',
    'Retail- Anchor',
    'Retail- Community Center',
    'Retail- Strip Center',
    'Retail- Specialty Center',
    'Retail- Neighborhood Center',
    'Retail- Outlet Center',
    'Retail- Regional Center/Mall',
    'Retail- Super Regional Center'
];
PropertyModel.BuildingClass = [
    'A',
    'B',
    'C',
    'D'
];
PropertyModel.Tenancy = [
    'Multi-Tenant',
    'Single-Tenant'
];
PropertyModel.Status = [
    'Existing',
    'Under Construction',
    'Under Renovation',
    'Proposed',
    'Demolished'
];
PropertyModel.SpaceStatus = [
    'None',
    'Available',
    'Leased',
    'Pending',
    'Vacant'
];
PropertyModel.ExportFields = {
    address: 'Address',
    buildingLocation: 'Building Location',
    category: 'Category',
    city: 'City',
    class: 'Class',
    county: 'County',
    country: 'Country',
    daysOnMarket: 'Days On Market',
    defaultImageAttachmentId: 'Default Image Attachment ID',
    description: 'Description',
    forSale: 'For Sale',
    landAcres: 'Land Acres',
    landSquareFeet: 'Land Square Feet',
    latitude: 'Latitude',
    longitude: 'Longitude',
    market: 'Market',
    name: 'Name',
    occupancy: 'Occupancy',
    ownerId: 'Owner ID',
    parcelNumber: 'Parcel Number',
    parkingSpaces: 'Parking Spaces',
    parkingRatio: 'Parking Ratio',
    postalCode: 'Postal Code',
    primaryUse: 'Primary Use',
    recentlySold: 'Recently Sold',
    recordTypeId: 'Record Type ID',
    saleDate: 'Sale Date',
    salePrice: 'Sale Price',
    squareFootage: 'Square Footage',
    state: 'State',
    status: 'Status',
    stories: 'Stories',
    street: 'Street',
    submarket: 'Submarket',
    tenancy: 'Tenancy',
    units: 'Units',
    yearBuilt: 'Year Built',
    yearRenovated: 'Year Renovated',
    zoning: 'Zoning'
};
exports.PropertyModel = PropertyModel;
//# sourceMappingURL=property.model.js.map